import { Component } from '@angular/core';

@Component({
  selector: 'app-permissions-home',
  templateUrl: './permissions-home.component.html',
  styleUrls: ['./permissions-home.component.css'],
})
export class PermissionsHomeComponent {
  options = [
    { 
      label: 'Regras por Membro', 
      description: 'Visualize e audite as permissões e funções atribuídas a cada membro específico.',
      route: '/permissoes/regras',
      icon: 'people',
      colorClass: 'color-blue'
    },
    { 
      label: 'Funções da Igreja', 
      description: 'Gerencie as funções (ex: Líder, Pastor) e vincule roles a elas.',
      route: '/permissoes/funcoes',
      icon: 'assignment_ind',
      colorClass: 'color-green'
    },
    { 
      label: 'Roles do Sistema', 
      description: 'Configure os perfis de acesso base que agrupam um conjunto de permissões.',
      route: '/permissoes/roles',
      icon: 'admin_panel_settings',
      colorClass: 'color-purple'
    },
    { 
      label: 'Entidades (Módulos)', 
      description: 'Cadastre e gerencie os módulos e telas que podem receber permissões.',
      route: '/permissoes/entidades',
      icon: 'view_module',
      colorClass: 'color-orange'
    },
  ];
}
